export default {
	title: 'Meu perfil',
	messages: {
		choose_plan: 'Escolher um plano',
		unlock_immediately: 'Desbloquear imediatamente todos os recursos',
		current_subscription: 'Sua assinatura atual'
	},
	language: {
		title: 'Idioma',
		description: 'Escolha o idioma da interface',
		languages: {
			de: 'Alemão',
			en: 'Inglês',
			es: 'Espanhol',
			fr: 'Francês',
			hi: 'Hindi',
			it: 'Italiano',
			ja: 'Japonês',
			pt: 'Português',
			zh: 'Chinês (mandarim)'
		}
	},
	theme: {
		title: 'Seleção de tema'
	},
	actions: {
		manage_subscription: 'Gerenciar minha assinatura'
	},
	api_access: {
	  title: "Acesso API (servidor MCP)",
	  description: "Permite que agentes de IA (Claude, ChatGPT, etc.) acessem seus projetos Gerositus via Model Context Protocol. O token concede o mesmo acesso que o seu — mantenha-o em segredo.",
	  endpoint: "URL do endpoint MCP",
	  no_token: "Ainda sem token — gere um para habilitar o acesso de agentes de IA.",
	  default_token_name: "Token padrão",
	  status_active: "Ativo",
	  status_revoked: "Revogado",
	  created_at: "Criado em {{date}}",
	  last_used_at: "Último uso em {{date}}",
	  never_used: "Nunca usado",
	  generate: "Gerar token",
	  regenerate: "Renovar token",
	  revoke: "Revogar token",
	  copy: "Copiar",
	  copied: "Copiado para a área de transferência",
	  copy_failed: "Falha ao copiar",
	  config_example: "Exemplo de configuração de cliente MCP",
	  reveal_title: "Salve seu token agora",
	  reveal_done: "Eu salvei",
	  reveal_warning_title: "Esta é a única vez que você verá este token",
	  reveal_warning_body: "Copie-o para um lugar seguro (gerenciador de senhas). Se o perder, terá que renová-lo. Qualquer pessoa com este token pode ler seus projetos.",
	  regenerate_confirm_title: "Renovar o token de acesso?",
	  regenerate_confirm_body: "O token atual será revogado imediatamente e um novo será emitido. Qualquer agente de IA usando o token antigo precisará ser reconfigurado.",
	  revoke_confirm_title: "Revogar o token de acesso?",
	  revoke_confirm_body: "Qualquer agente de IA com este token perderá o acesso. Você pode gerar um novo a qualquer momento."
	}
};
